import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from "react-router";
// import MainBanner from './../components/main-banner/MainBanner';
import Heading from '../components/heading/Heading';
// import UploadDragDrop from '../components/upload-drag-drop/UploadDragDrop';
import LeasingItems from '../components/leasing-items/LeasingItems';
import ProviderInfo from '../components/provider-info/ProviderInfo';
import TypeOfContract from '../components/type-of-contract/TypeOfContract';
import LeasingRate from '../components/leasing-rate/LeasingRate';
import { percentageCalc } from '../services/percentageCalc';
import { getApiLink } from './../services/getApiLink';
import { convertPrice } from './../services/convertPrice';
import { getMinimumMonths } from './../services/getMinimumMonths';
import { getAmortization } from './../services/getAmortization';

import phpFile from './../sessiondata.php'
import StepBar from '../components/steps-bar/StepsBar';
import SendEmailCalc from '../components/send-calc-email/SendCalcEmail';
import LineSeperator from '../components/line-seperator/LineSeperator';
import getDataFromUrl from '../services/getDataFromUrl';
import Benefits from '../components/benefits/Benefits';
import Text from '../components/text/Text';


const HomePageContainer = ( props ) => {
    let tempPrice = 0;

    let [ rate4, setRate4 ] = useState('');
    let [ rate12, setRate12 ] = useState('');
    let [ fileData, setFileData ] = useState([{tables: '', seller: ''}]);
    let [ calculateRate, setCalculateRate ] = useState(false);
    let [ activeRate4, setActiveRate4 ] = useState(true);
    let [ forceValidate, setForceValidate ] = useState(false);
    let [ forceValidateItems, setForceValidateItems ] = useState(false);
    let [ errors, setErrors ] = useState(true);
    let [ retryCalc, setRetryCalc ] = useState(false);
    let [ showTax, setShowTax ] = useState(true);
    let [ clickedButton, setClickedButton ] = useState(0);
    let [ updateType, setUpdateType ] = useState(0);
    let [ loadDbCount, setLoadDbCount ] = useState(0);
    let [ minimumMonth, setMinimumMonth ] = useState(false);
    let [ changesInCalculator, setChangesInCalculator ] = useState(false); // check changes in calc
    let [ resetEmailCalc, setResetEmailCalc ] = useState(0);
    let [ load, setLoad ] = useState(false);

    let navigate = useNavigate();
    const dispatch = useDispatch()
    let products            = useSelector(state => state.products)
    let leasingTime         = useSelector(state => state.leasingTime)
    let initialCharge       = useSelector(state => state.initialCharge)
    let productPrice        = useSelector(state => state.productPrice)
    let activeContract      = useSelector(state => state.selectedLease)
    let tax                 = useSelector(state => state.tax)
    let repurchase          = useSelector(state => state.repurchase)
    let provider            = useSelector(state => state.provider)
    let errorAddProductFV   = useSelector(state => state.errorAddProductFV)
    let visitedStep         = useSelector(state => state.visitedStep)
    let maxThreshold        = useSelector(state => state.maxThreshold)
    let minThreshold        = useSelector(state => state.minThreshold)
    let errorFvUpload       = useSelector(state => state.errorFvUpload);
    let disableUpload       = useSelector(state => state.disableUpload);
    let uploadValidate      = useSelector(state => state.uploadValidate);

    let loadDataDefault = () => {
        if ( typeof(leasingTime) == 'object' ) {
            let session = window.AppConfig;
            let priceUrl = getDataFromUrl("c");
            let categoryUrl = getDataFromUrl("k");
            // dispatch({ type: 'LEASING_TIME_CHANGE', value: session ? session.minMonths.toString() : '18'})
            if ( !categoryUrl ) {
                dispatch({ type: 'LEASING_TIME_CHANGE', value: session ? session.defaultMonths.toString() :  '12' })
            }
            dispatch({ type: 'INITIAL_CHARGE_CHANGE', value: session ? session.initial +'%': '0%' })
            dispatch({ type: 'CHARGE_PRICE_CHANGE', value: '0 AED' })
            if ( !priceUrl ) {
                dispatch({ type: 'PRODUCT_PRICE_CHANGE', value: session ? session.value : '0.00' });
                dispatch({ type: 'MIN_MONTH_CHANGE', value: session ? session.minMonths : '12' })
            }
            dispatch({ type: 'TAX_CHANGE', value: session ? convertPrice(session.price.toString() ) + " AED" : '0 AED' })
            dispatch({ type: 'PRODUCT_PRICE_END_CHANGE', value: '0,00 AED' })
            dispatch({ type: 'SELECTED_LEASE_CHANGE', value: session ? session.selectedLeaseType : 'nowoczesny' })
            dispatch({ type: 'MODERN_LEASE_CHANGE', value: session ? session.enableModernLease : true })
            dispatch({ type: 'TRADITIONAL_LEASE_CHANGE', value: session ? session.enableTraditionalLease : true })
            dispatch({ type: 'MAX_MONTH_CHANGE', value: session ? session.maxMonths : '48' })            
            dispatch({ type: 'ALLOW_FORM_CHANGE', value: session ? session.allowForm : true })
            dispatch({ type: 'MIN_INITIAL_CHARGE_CHANGE', value: session ? session.minInitial +'%': '0%' })
            dispatch({ type: 'MAX_INITIAL_CHARGE_CHANGE', value: session ? session.maxInitial +'%': '30%' })

            // dispatch({ type: 'LEGAL_FORM_CHANGE', value: session ? session.legalForm : true })            
            dispatch({ type: 'PROVIDER_CHANGE', value: session ? session.provider : true })
            dispatch({ type: 'PROVIDER_NAME_CHANGE', value: session ? session.providerName : '' });
            dispatch({ type: 'PROVIDER_POSTAL_CHANGE', value: session ? session.providerPostal : '' });

            dispatch({ type: 'IS_SHOP_CHANGE', value: false })
            dispatch({ type: 'COURIER_CHANGE', value: session ? session.courier : true })
            dispatch({ type: 'URL_FORM_FINISH_CHANGE', value: session ? session.urlFormFinish : window.location.host })
            dispatch({ type: 'URL_FORM_FINISH_EXTERNAL_CHANGE', value: session ? session.urlFormFinishExternal : window.location.host })
            dispatch({ type: 'RATE_CHANGE', value: session ? session.rate : ['kwartalna', 'miesieczna'] })
            dispatch({ type: 'RATE_FREQUENCY_CHANGE', value: session ? session.rateFrequency : 'kwartalnie'})
            dispatch({ type: 'SHOW_ESIGN_CHANGE', value: session ? session.showEsign : true})
            dispatch({ type: 'SHOW_ESIGN_MAX_PRICE_CHANGE', value: session ? session.showEsignMaxPrice : 100000})
            dispatch({ type: 'SHOW_TAX_CHANGE', value: session ? session.startTax : true})
            dispatch({ type: 'MIN_THRESHOLD_CHANGE', value: session ? session.minThreshold : 20000.00})
            dispatch({ type: 'MAX_THRESHOLD_CHANGE', value: session ? session.maxThreshold : 50000.00})
            if( session && session.products) {
                addProducts(session.products)
            }
        }
    }

    let loadSession = (key) => {
        var keyGlobal = key;
        let req = new XMLHttpRequest();
        let data = {
            "key": key,
        }
        req.open('POST', `${ getApiLink() }/setSession.php`);
        req.setRequestHeader("Content-Type", "application/json;charset=UTF-8"); 
        req.send(JSON.stringify(data));
        req.addEventListener("readystatechange", async function () {
          if (this.readyState === 4) {
                await loadDataFromDb(keyGlobal)
            }
        })

    }
    let loadDataFromDb = (key) => {
        let session = window.AppConfig;

        let req = new XMLHttpRequest();
        let data = {
            "key": key,
        }
        req.open('POST', `${ getApiLink() }/getCalculation.php`);
        req.setRequestHeader("Content-Type", "application/json;charset=UTF-8"); 
        req.send(JSON.stringify(data));

        req.addEventListener("readystatechange", async function () {
          if (this.readyState === 4) {

                let resp = JSON.parse(req.response);
                // let prod = JSON.parse(resp.products.substr(1).slice(0, -1))
                await dispatch({ type: 'FROM_DB_LOADED_CHANGE', value: true })
                await dispatch({ type: 'SET_PRODUCTS', value: resp.products })
                await dispatch({ type: 'LEASING_TIME_CHANGE', value: resp.leasingTime })
                await dispatch({ type: 'INITIAL_CHARGE_CHANGE', value: resp.initialCharge })
                await dispatch({ type: 'CHARGE_PRICE_CHANGE', value: resp.chargePrice })
                await dispatch({ type: 'PRODUCT_PRICE_CHANGE', value: resp.productPrice  })
                await dispatch({ type: 'TAX_CHANGE', value: resp.tax })
                await dispatch({ type: 'PRODUCT_PRICE_END_CHANGE', value: resp.productPriceEnd })
                await dispatch({ type: 'SELECTED_LEASE_CHANGE', value: resp.selectedLease })
                await dispatch({ type: 'MODERN_LEASE_CHANGE', value: (resp.modernLease == '1' ? true : false) })
                await dispatch({ type: 'TRADITIONAL_LEASE_CHANGE', value: (resp.traditionalLease == '1' ? true : false) })
                await dispatch({ type: 'MIN_MONTH_CHANGE', value: resp.minMonth })
                await dispatch({ type: 'PROVIDER_CHANGE', value: (resp.provider == "1" ? true : false) })
                await dispatch({ type: 'PROVIDER_POSTAL_CHANGE', value: resp.providerPostal })
                await dispatch({ type: 'PROVIDER_NAME_CHANGE', value: resp.providerName })
                await dispatch({ type: 'PROVIDER_NIP_CHANGE', value: resp.providerNip })
                await dispatch({ type: 'RATE_FREQUENCY_CHANGE', value: resp.rateFrequency ? resp.rateFrequency : 'kwartalnie'})
                await dispatch({ type: 'FINAL_RATE_CHANGE', value: resp.finalRate })
                await dispatch({ type: 'OPENED_MAIL_CHANGE', value: (resp.openedMail == "1" ? true : false) })
                await dispatch({ type: 'ALLOW_FORM_CHANGE', value: (resp.allowForm == "1" ? true : false) })

                // await dispatch({ type: 'LEGAL_FORM_CHANGE', value: (resp.legalFormlegalForm == "1" ? true : false) })            
                await dispatch({ type: 'COURIER_CHANGE', value: (resp.courier == "1" ? true : false) })
                await dispatch({ type: 'URL_FORM_FINISH_CHANGE', value: resp.urlFormFinish })
                await dispatch({ type: 'RATE_CHANGE', value: JSON.parse(resp.rate) })
                await dispatch({ type: 'MIN_THRESHOLD_CHANGE', value: session ? session.minThreshold : 20000.00})
                await dispatch({ type: 'MAX_THRESHOLD_CHANGE', value: session ? session.maxThreshold : 50000.00})

                // await dispatch( {type: 'DISABLE_UPLOAD', value: true} );
                if(resp.paramsUrl) {
                    if(resp.paramsUrl == 1) {
                        await dispatch( {type: 'DISABLE_UPLOAD', value:  true } );
                        await dispatch( {type: 'UPLOAD_VALIDATE', value:  true } );
                    }else{
                        await dispatch( {type: 'DISABLE_UPLOAD', value:  false } );
                    }
                }else{
                    await dispatch( {type: 'DISABLE_UPLOAD', value:  true } );
                }
                // await dispatch( {type: 'UPLOAD_VALIDATE', value:  true } );
                await wait(3000)
                await setLoadDbCount(++loadDbCount);

            }
        });
    }
    
    let addProducts = async(newProducts) => {
        let tempProducts = []
        await newProducts.map(el => {
            tempProducts = [...tempProducts, {
                name: el.name,
                price: convertPrice(el.price),
                quantity: el.quantity,
                type: el.category ? el.category : '',
                amortization: el.category ? getAmortization(el.category) : '',
                added: el.added
            }]
        })
        await dispatch( {type: 'SET_PRODUCTS', value:  tempProducts } )
    }

    // when product was update
    useEffect(() => {
        updateProduct();
    }, [products])

    let updateProduct = () => {
        if ( products.length > 0 ) {
            if ( activeContract != 'nowoczesny') {
                let min = getMinimumMonths(products);
                setMinimumMonth(min)
                dispatch({ type: 'MIN_MONTH_CHANGE', value: min});
            }
        }
    }

    //load php file
    let addPhpScript = () => {
        const script = document.createElement("script");
        script.src = phpFile;
        script.type = "text/javascript";
        document.head.appendChild(script);
    }

    // on First load 
    useEffect(() => {
        if ( !load ) {
            tempPrice = productPrice;
            const loadInit = async () => {
                await dispatch({ type: 'INIT_STEPS' });
                await dispatch({ type: 'STEPS_CHANGE', value: 1 })
                if ( props?.match?.params?.key && props.match.params.key != null) {
                    if ( !productPrice || productPrice === '0 AED' || productPrice.length == 0) {
                        await loadSession(props.match.params.key);
                    }
                    await wait(2000)
                    await addPhpScript(); 
                    await dispatch({ type: 'MIN_THRESHOLD_CHANGE', value:  window.AppConfig ?  window.AppConfig.minThreshold : 20000.00})
                    await dispatch({ type: 'MAX_THRESHOLD_CHANGE', value:  window.AppConfig ?  window.AppConfig.maxThreshold : 50000.00})
                    // await addPhpScript(); 
                    // await loadSession(props.match.params.key);
                    // await wait(200)
                    //  TE POWYZEJ DLA NORD SERVER
                } else {
                    await addPhpScript(); 
                    await wait(2000)
                    await loadDataDefault();
                }
            }
            loadInit();
            setLoad(true);
        } 
    }, [load])
     // Do when data was change
     useEffect(() => {
         if ( errors ) {
            setCalculateRate(false);
            setForceValidate(false);
         } else {
            setRetryCalc(true);
         }

    }, [errors])

    // Do when initial charge and product price was change
    useEffect(() => {
        let fn;
        switch ( initialCharge ) {
            case "0%":
                fn = percentageCalc( 0, productPrice);
                dispatch({ type: 'CHARGE_PRICE_CHANGE', value: convertPrice(fn.charge.toString())  + " zł" })                
                dispatch({ type: 'PRODUCT_PRICE_END_CHANGE', value: convertPrice(repurchase.toString())  + " zł" })
                break;

            case "5%":
                fn = percentageCalc( 0.05, productPrice);

                dispatch({ type: 'CHARGE_PRICE_CHANGE', value: convertPrice(fn.charge.toString())  + " zł" })                
                dispatch({ type: 'PRODUCT_PRICE_END_CHANGE', value: convertPrice(repurchase.toString())  + " zł" })
                break;

            case "10%":
                fn = percentageCalc( 0.1, productPrice);

                dispatch({ type: 'CHARGE_PRICE_CHANGE', value: convertPrice(fn.charge.toString())  + " zł" })                
                dispatch({ type: 'PRODUCT_PRICE_END_CHANGE', value: convertPrice(repurchase.toString())  + " zł" })
                break;

            case "15%":
                fn = percentageCalc( 0.15, productPrice);

                dispatch({ type: 'CHARGE_PRICE_CHANGE', value: convertPrice(fn.charge.toString())  + " zł" })                
                dispatch({ type: 'PRODUCT_PRICE_END_CHANGE', value: convertPrice(repurchase.toString())  + " zł" })
                break;
            
            case "20%":
                fn = percentageCalc( 0.2, productPrice);
                dispatch({ type: 'CHARGE_PRICE_CHANGE', value: convertPrice(fn.charge.toString())  + " zł" })                
                dispatch({ type: 'PRODUCT_PRICE_END_CHANGE', value: convertPrice(repurchase.toString())  + " zł" })
                break;

            case "25%":
                fn = percentageCalc( 0.25, productPrice);
                dispatch({ type: 'CHARGE_PRICE_CHANGE', value: convertPrice(fn.charge.toString())  + " zł" })                
                dispatch({ type: 'PRODUCT_PRICE_END_CHANGE', value: convertPrice(repurchase.toString())  + " zł" })
                break;

            case "30%":
                fn = percentageCalc( 0.3, productPrice);
                dispatch({ type: 'CHARGE_PRICE_CHANGE', value: convertPrice(fn.charge.toString())  + " zł" })                
                dispatch({ type: 'PRODUCT_PRICE_END_CHANGE', value: convertPrice(repurchase.toString())  + " zł" })
                break;

            default:
                break;
        }
   }, [initialCharge, productPrice, repurchase])

    // Do when data was change
    useEffect(() => {
        setForceValidate(false)
        setChangesInCalculator(true);
        recalculateRates();

    }, [fileData, productPrice, activeContract, initialCharge, leasingTime, updateType, loadDbCount])

    useEffect(() => {
        checkVisitedSteps();
    }, [productPrice])

    const checkVisitedSteps= () => {
        let copyVisited = visitedStep;
        // console.log(copyVisited);

        let checkMinTrash = tempPrice < minThreshold && productPrice >= minThreshold; //check for 20000
        let checkMaxTrash = tempPrice < maxThreshold && productPrice >= maxThreshold; //check for 50000
        
        if ( visitedStep.length > 1 && productPrice != tempPrice && ( checkMinTrash || checkMaxTrash ) ) {
            if ( copyVisited.indexOf(5) > -1 ) {
                copyVisited.splice( copyVisited.indexOf(5), 1 );
            }
        } 
        dispatch({ type: 'VISITED_STEP_CHANGE', value: copyVisited })

    }

    // Do when click submit button
    // useEffect(() => {
       
    //     const checkForm = async () => {
    //         if ( calculateRate ) { 
    //             await setForceValidate(true);
    //             await wait(500);
    //             let scroll = await scrollPage();
    //             if ( scroll ) {
    //                 await setErrors(true);
    //             } else {
    //                 alert('Nie ma błędów.')
    //             }
    //         } else {
    //             await setErrors(true);
    //         }
    //       };
    //       checkForm();
        
    // }, [clickedButton])
    
    async function wait(ms) {
        return new Promise(resolve => {
          setTimeout(resolve, ms);
        });
    }

    let scrollPage = ( ) => {
        let result;
        let elements = document.querySelectorAll('.error-item');
       

        if( elements.length > 0 ) {
            let topElement = elements[0].getBoundingClientRect().top;
            let windowScroll = window.scrollY;
            window.scroll({
                behavior: 'smooth',
                left: 0,
                top: windowScroll + topElement - 140
              });
            result = true;
        } else {
            result = false;
        }
        return result;
    }

    let recalculateRates = () => {
        let valuePrice = productPrice;
            valuePrice = valuePrice.replace(/ /g,'');
            valuePrice = valuePrice.replace('AED', '');
            valuePrice = valuePrice.replace(',','.');
        
        let valueTax = tax;
            valueTax = valueTax.replace(/ /g,'');
            valueTax = valueTax.replace('AED', '');
            valueTax = valueTax.replace(',','.');

        let valueInitial = initialCharge;
            valueInitial = valueInitial.replace(/ /g,'');
            valueInitial = valueInitial.replace('AED', '');
            valueInitial = valueInitial.replace(',','.');
            valueInitial = valueInitial.replace('%','');

        let req = new XMLHttpRequest();
        let data = {
            "type": activeContract,
            "value": valuePrice,
            "price": valueTax,
            "initial": valueInitial,
            "months": leasingTime,
            "products": products
        }
        if ( (window.AppConfig || window.location.hostname === 'localhost') && parseInt(productPrice) > 0) {
            req.open('POST', `${ getApiLink() }/calculate.php`);
            req.setRequestHeader("Content-Type", "application/json;charset=UTF-8"); 
            req.send(JSON.stringify(data));
            
            req.addEventListener("readystatechange", async function () {
            if (this.readyState === 4) {
                let resp = JSON.parse(req.response);
                    if ( resp != 'error') {
                        console.log(resp);
                        if ( resp.result.month == '--' || resp.result.quater == '--' ) {
                            dispatch({ type: 'TAX_CHANGE', value: '0,00 AED'})
                            setRate12('0,00 AED');
                            setRate4('0,00 AED');
                            dispatch({ type: 'REPURCHASE_CHANGE', value: 0.00 }); 
                        } else {
                            dispatch({ type: 'TAX_CHANGE', value: convertPrice(resp.result.price.toFixed(2) ) + " AED" })
                            dispatch({ type: 'FACTOR_CHANGE', value: resp.result.factor })
                            dispatch({ type: 'TABLE_NAME_WP_CHANGE', value: resp.result.tableName })
                            setRate12(resp.result.month);
                            setRate4(resp.result.quater);
                            // dispatch({ type: 'REPURCHASE_CHANGE', value: parseFloat(resp.result.repurchase).toFixed(2) });              
                        }
                        
                    }
                }
            });
        }
        
    }
    let changePage = async (status = false, resetCalcInput = false) => {
        if(resetCalcInput) {
            setResetEmailCalc(++resetEmailCalc)
        }
        await setClickedButton(clickedButton + 1);
        await setForceValidate(true);
        await wait(500);
        let scroll = await scrollPage();
        if ( scroll ) {
            await setErrors(true);
        } else {
            if(!status) {
                // props.history.push('/krok/2')
                navigate('/krok/2')
            }
        }
    }

    const toggleFileData = async(data) => {
        await setFileData([{tables: '', seller: ''}]);
        await setFileData(data);
    }
    
    return (
        <>
            <section className="calculator-form" id="calculator">
                <div className="container">
                    <div className="row">
                        <LeasingItems  data={ fileData[0].tables }
                                        recalculateRates={ () => recalculateRates() }
                                        updateProducts={ () => updateProduct() }
                                        forceValidate={ forceValidate } 
                                        forceValidateItems={ forceValidateItems }
                                        setForceValidateItems={ (val) => setForceValidateItems(val) } 
                                        clickedButton={ clickedButton } 
                                        price4={ rate4 }
                                        price12={ rate12 } 
                                        setUpdateType={ () => setUpdateType(updateType + 1) } />
                    </div>
                    <div className="row">
                        { provider && 
                            <ProviderInfo forceValidate={ forceValidate } zip={( !(window.AppConfig && window.AppConfig.providerName.length > 0) && fileData[0].seller.zipcode ? fileData[0].seller.zipcode.ans.val : '')} name={( !(window.AppConfig && window.AppConfig.providerName.length > 0) && fileData[0].seller.name ? fileData[0].seller.name.ans.val : '')} nip={ fileData[0].seller.nip ? fileData[0].seller.nip.ans.val : '' }/>
                        }
                    </div>
                    <div className="row">
                        <div className="cols lease-calculation">
                            <div className="col">
                            <TypeOfContract productPrice={ productPrice } 
                                                setCalculateRate={ async (val) => { await setCalculateRate(val); await setChangesInCalculator(false) } } 
                                                setClickedButton={(val) => setClickedButton(val)}
                                                clickedButton={ clickedButton } 
                                                retryCalc={retryCalc} 
                                                changesInCalculator={changesInCalculator}
                                                minimumMonth={ minimumMonth } 
                                                loadDbCount={ loadDbCount } />
                            </div>
                            <div className="col">
                            <LeasingRate activeRate4={ activeRate4 } 
                                            activeContract={ (activeContract == 'tradycyjny' ? 1 : 2) }
                                            calculateRate={ calculateRate } 
                                            rate4={ rate4 }
                                            rate12={ rate12 } 
                                            changePage={ () => changePage(false, true) }
                                            forceValidate={ forceValidate } />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="cols send-email">
                            <div className="col">
                                < Benefits />
                            </div>
                            <div className="col">
                                < SendEmailCalc rate4={ rate4 }
                                        rate12={ rate12 }
                                        resetEmailInput={resetEmailCalc} 
                                        changePage={ (status) => changePage(status) }/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default HomePageContainer;